document.addEventListener('DOMContentLoaded', async () => {
  import('utility/page-restore').then((module) => module.default.init())
  import('utility/prefetch').then((module) => module.default.init())
  // import('utility/recaptcha')
  import('utility/smooth-scroll').then((module) => module.default.init())
  import('utility/vertical-resize-check').then((module) => module.default.init())

  document.querySelector<HTMLElement>('.body').classList.remove('noscript')

  if (document.querySelector<HTMLElement>('.accordion')) {
    import('components/accordion').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.article-video-block')) {
    import('blocks/video-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.infogram-block')) {
    import('blocks/infogram-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.article-video-block__video-embed')) {
    import('utility/video-overlay').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.video')) {
    import('components/video').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.authentication-page')) {
    import('components/authentication').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.auth-form')) {
    import('components/auth-form').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.contact-page')) {
    import('components/contact-us-form-validation').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.chat')) {
    import('components/chat').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.hero')) {
    import('components/hero').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-file')) {
    import('components/input-file').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-group')) {
    import('components/input-group').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.picture')) {
    import('components/picture').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.tariff-block')) {
    import('blocks/tariff-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.tariff-block')) {
    import('components/tariff-block-automation').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.tariff-block')) {
    import('components/accordion-tariff').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.staff-page')) {
    import('components/staff-search').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.fake-select')) {
    import('components/fake-select').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.body:not(.body-ar)')) {
    if (document.querySelector<HTMLElement>('.header-navigation')) {
      import('components/navigation').then((module) => module.default.init())
    }

    setTimeout(() => {
      document.querySelector<HTMLElement>('.body').classList.remove('body--loading')
    }, 100)
  }

  if (document.querySelector<HTMLElement>('.body-ar')) {
    import('sections/banner-ar').then((module) => module.default.init())
    import('sections/header-ar').then((module) => module.default.init())
    import('sections/main-ar').then((module) => module.default.init())
    import('components/progress-ar').then((module) => module.default.init())

    setTimeout(() => {
      document.querySelector<HTMLElement>('.body-ar').classList.remove('body-ar--loading')
    }, 100)
  }

  if (process.env.NODE_ENV !== 'production') {
    import('utility/keyboard-shortcuts').then((module) => {
      module.contentEditable.init()
      module.goToStyleguide.init()
    })
    import('utility/overlay-grid').then((module) => module.default.init())
  }

  setTimeout(() => {
    document.querySelector('.body').classList.add('loaded')
  }, 100)

  setTimeout(() => {
    document.querySelector('.body').classList.add('preload--hidden')
    document.querySelector('.body').classList.remove('preload--transitions')
  }, 400)
})
